@if (!compactView) {
  <label class="form-label fw-bold">{{label}}</label>
}
@if (compactView) {
  <div class="selected-language">
    <div class="d-flex align-items-center justify-content-center">
      <img [src]="selectedLanguageDetails?.flag"
        [alt]="selectedLanguageDetails?.label"
        class="flag-image active">
    </div>
  </div>
} @else {
  @if (languages) {
    <div class="language-selector" role="group">
      @for (lang of languages; track lang) {
        <div class="flag-container">
          <input type="radio"
            class="flag-input"
            [id]="'lang-' + lang?.language?.name?.toLowerCase()"
            [value]="lang?.language?.languageId"
            [checked]="isLanguageSelected(lang)"
            [disabled]="disabled"
            (change)="onLanguageSelect(lang)">
          <label class="flag-label" [for]="'lang-' + lang?.language?.name?.toLowerCase()">
            <img [src]="lang?.flag" [alt]="lang?.language?.name" class="flag-image">
          </label>
        </div>
      }
    </div>
  }
}
